import React from "react";
import {View as RNView} from "react-native";

export default React.memo(
	function MockStatusBar({props}) {
		return <RNView {...props}/>;
	}
)